const AppStorage = {
  getItem(key) {
    return localStorage.getItem(key);
  },

  setItem(key, value) {
    return localStorage.setItem(key, value);
  },

  deleteItem(key) {
    return localStorage.removeItem(key);
  },

  clearAll() {
    return localStorage.clear();
  },
};

export default AppStorage;
